export class WebhookV1StandardPayloadMpaReviewArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaReviewNotification",
            "baseName": "mpaReviewNotification",
            "type": "WebhookV1MPAReviewNotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadMpaReviewArguments.attributeTypeMap;
    }
    constructor() {
    }
}
